<template>
  <div>
    <router-view id="page-content-wrapper"></router-view>
  </div>
</template>

<script>
export default {
  name: "CrewChangeIndex"
}
</script>

<style scoped>

</style>